module.exports = __webpack_public_path__ + "img/learning_management.eb4f8c9d.jpg";